<template>
  <pop-view @onCloseClick="onCloseClick">
    <div class="device-outbound">
      <div class="device-outbound-top">
        <p class="device-outbound-top-title">设备出库</p>
        <img
          class="device-outbound-top-close"
          src="@imgs/close-card.png"
          @click="onCloseClick"
        />
      </div>
      <div class="device-outbound-middle">
        <!-- 第一行：设备属性 + 设备状态 -->
        <div class="form-row">
          <div class="form-field">
            <p class="form-field-title"><span class="required">*</span>设备属性：</p>
            <el-select
              v-model="deviceAttribute"
              placeholder="请选择设备属性"
              class="form-field-select"
              @change="onDeviceAttributeChange"
            >
              <el-option label="正式进院" :value="1"></el-option>
              <el-option label="试用" :value="2"></el-option>
            </el-select>
          </div>
          <div class="form-field">
            <p class="form-field-title"><span class="required">*</span>设备状态：</p>
            <el-select
              v-model="deviceStatus"
              placeholder="请选择设备状态"
              class="form-field-select"
              disabled
            >
              <el-option label="已售" :value="2"></el-option>
              <el-option label="流转中" :value="3"></el-option>
            </el-select>
          </div>
        </div>

        <!-- 第二行：同步出库指环1 + 同步出库指环2（仅ZG-S01D设备型号显示） -->
        <div class="form-row" v-if="shouldShowRings">
          <div class="form-field">
            <p class="form-field-title">同步出库指环：</p>
            <el-select
              v-model="outboundRing1"
              placeholder="请选择指环"
              class="form-field-select"
              filterable
              clearable
            >
              <el-option
                v-for="ring in ring1List"
                :key="ring.value"
                :label="ring.label"
                :value="ring.value"
              ></el-option>
            </el-select>
          </div>
          <div class="form-field">
            <p class="form-field-title">同步出库指环：</p>
            <el-select
              v-model="outboundRing2"
              placeholder="请选择指环"
              class="form-field-select"
              filterable
              clearable
            >
              <el-option
                v-for="ring in ring2List"
                :key="ring.value"
                :label="ring.label"
                :value="ring.value"
              ></el-option>
            </el-select>
          </div>
        </div>

        <!-- 第三行：负责人 + 关联机构 -->
        <div class="form-row">
          <div class="form-field">
            <p class="form-field-title"><span class="required">*</span>负责人：</p>
            <el-select
              v-model="outboundPersonId"
              placeholder="请选择负责人"
              class="form-field-select"
              filterable
            >
              <el-option
                v-for="person in personList"
                :key="person.value"
                :label="person.label"
                :value="person.value"
              ></el-option>
            </el-select>
          </div>
          <div class="form-field">
            <p class="form-field-title">关联机构：</p>
            <el-select
              v-model="outboundHospitalId"
              placeholder="请选择机构"
              class="form-field-select"
              filterable
            >
              <el-option
                v-for="hospital in hospitalList"
                :key="hospital.value"
                :label="hospital.label"
                :value="hospital.value"
              ></el-option>
            </el-select>
          </div>
        </div>

        <!-- 第四行：出库时间 + 质保年数（仅正式进院显示） -->
        <div class="form-row" v-if="deviceAttribute === 1">
          <div class="form-field">
            <p class="form-field-title">出库时间：</p>
            <el-date-picker
              v-model="outboundTime"
              type="date"
              placeholder="选择出库时间"
              value-format="yyyy-MM-dd"
              class="form-field-picker"
            >
            </el-date-picker>
          </div>
          <div class="form-field">
            <p class="form-field-title">质保年数：</p>
            <el-select
              v-model="warrantyYears"
              placeholder="请选择质保年数"
              class="form-field-select"
            >
              <el-option label="1年" :value="1"></el-option>
              <el-option label="2年" :value="2"></el-option>
              <el-option label="3年" :value="3"></el-option>
              <el-option label="4年" :value="4"></el-option>
              <el-option label="5年" :value="5"></el-option>
              <el-option label="6年" :value="6"></el-option>
              <el-option label="7年" :value="7"></el-option>
              <el-option label="8年" :value="8"></el-option>
              <el-option label="9年" :value="9"></el-option>
              <el-option label="10年" :value="10"></el-option>
            </el-select>
          </div>
        </div>

        <!-- 第五行：关联合同编号 + 签订合同对象（仅正式进院显示） -->
        <div class="form-row" v-if="deviceAttribute === 1">
          <div class="form-field">
            <p class="form-field-title">关联合同编号：</p>
            <border-input
              class="form-field-input"
              :initalValue="contractNumber"
              @onInput="onContractNumberInput"
            ></border-input>
          </div>
          <div class="form-field">
            <p class="form-field-title">签订合同对象：</p>
            <border-input
              class="form-field-input"
              :initalValue="contractSignatory"
              @onInput="onContractSignatoryInput"
            ></border-input>
          </div>
        </div>

        <!-- 第六行：备注（仅正式进院显示） -->
        <div class="form-row" v-if="deviceAttribute === 1">
          <div class="form-field">
            <p class="form-field-title">备注：</p>
            <el-input
              v-model="outboundRemarks"
              type="textarea"
              placeholder="请输入备注"
              class="form-field-textarea"
              :rows="2"
            >
            </el-input>
          </div>
          <!-- <div class="form-field">
           
          </div> -->
        </div>

        <!-- 文案提示区域 -->
        <div class="form-tips" v-if="shouldShowTips">
          <p class="form-tips-title">解除原来之间的关联关系并同时切换到新选择的机构：</p>
          <div class="form-tips-content">
            <p v-if="deviceData">
              <span v-if="deviceData.deviceHospitalName">
                {{ deviceData.model }}（sn：{{ deviceData.deviceSn || '--' }}）与{{ deviceData.deviceHospitalName }}
              </span>
              <span v-else>
                {{ deviceData.model }}（sn：{{ deviceData.deviceSn || '--' }}）不存在 机构关联信息
              </span>
            </p>
            <p v-for="ring in allRingTips" :key="ring.id">
              <span v-if="ring.hospitalName">
                指环（sn：{{ ring.deviceSn || '--' }}）与{{ ring.hospitalName }}
              </span>
              <span v-else>
                指环（sn：{{ ring.deviceSn || '--' }}）不存在 机构关联信息
              </span>
            </p>
          </div>
        </div>
      </div>
      <div class="device-outbound-bottom">
        <button class="device-outbound-bottom-cancel" @click="onCancelClick">取消</button>
        <button class="device-outbound-bottom-confirm" @click="onConfirmClick">确定</button>
      </div>
    </div>
  </pop-view>
</template>

<script>
import PopView from "@c/common/pop-view.vue";
import BorderInput from "@c/common/border-input.vue";
import { Select, Option, DatePicker, Input } from "element-ui";

export default {
  components: {
    PopView,
    BorderInput,
    ElSelect: Select,
    ElOption: Option,
    ElDatePicker: DatePicker,
    ElInput: Input,
  },

  props: {
    deviceData: {
      type: Object,
      default: () => ({})
    },
    hospitalList: {
      type: Array,
      default: () => []
    }
  },

  data: function () {
    const today = new Date();
    const year = today.getFullYear();
    const month = String(today.getMonth() + 1).padStart(2, '0');
    const day = String(today.getDate()).padStart(2, '0');
    const todayDate = `${year}-${month}-${day}`;

    return {
      deviceAttribute: null,
      deviceStatus: null,
      outboundRing1: null,
      outboundRing2: null,
      outboundPersonId: null,
      outboundHospitalId: null,
      outboundTime: todayDate,
      warrantyYears: null,
      contractNumber: "",
      contractSignatory: "",
      outboundRemarks: "",
      personList: [],
      ring1List: [],
      ring2List: [],
    };
  },

  computed: {
    // 判断是否显示指环选择（仅ZG-S01D设备型号）
    shouldShowRings() {
      return this.deviceData && this.deviceData.model === 'ZG-S01D';
    },

    // 判断是否显示提示信息（试用设备时显示）
    shouldShowTips() {
      return this.deviceAttribute === 2; // 试用设备
    },

    // 获取初始化的指环关联信息（来自syncOutboundRingHospitals）
    initialRingTips() {
      const tips = [];
      if (this.deviceData && this.deviceData.syncOutboundRingHospitals && Array.isArray(this.deviceData.syncOutboundRingHospitals)) {
        this.deviceData.syncOutboundRingHospitals.forEach(ringData => {
          tips.push({
            id: ringData.id,
            deviceSn: ringData.ringSn || '--',
            hospitalName: ringData.hospitalName || '未知机构'
          });
        });
      }
      return tips;
    },

    // 获取选中的指环提示信息（选择新指环时）
    selectedRingTips() {
      const tips = [];
      if (this.outboundRing1) {
        const ring1 = this.ring1List.find(ring => ring.value === this.outboundRing1);
        if (ring1) {
          tips.push({
            id: ring1.value,
            deviceSn: ring1.deviceSn || ring1.label,
            hospitalName: ring1.deviceHospitalName || '未知机构'
          });
        }
      }
      if (this.outboundRing2) {
        const ring2 = this.ring2List.find(ring => ring.value === this.outboundRing2);
        if (ring2) {
          tips.push({
            id: ring2.value,
            deviceSn: ring2.deviceSn || ring2.label,
            hospitalName: ring2.deviceHospitalName || '未知机构'
          });
        }
      }
      return tips;
    },

    // 显示的指环信息：如果有选中的指环则显示选中的，否则显示初始的
    allRingTips() {
      // 如果用户选择了新指环，则显示新选择的指环，替换原有的
      if (this.selectedRingTips.length > 0) {
        return this.selectedRingTips;
      }
      // 否则显示初始的指环信息
      return this.initialRingTips;
    }
  },

  async mounted() {
    await this.getPersonList();
  },

  methods: {
    async getPersonList() {
      try {
        // 获取负责人列表
        const response = await this.$api.getResponsiblePersonList();
        this.personList = response.map(item => ({
          value: item.id,
          label: item.trueName
        }));
      } catch (error) {
        console.error('获取负责人列表失败:', error);
      }
    },


    async getRingList() {
      try {
        // 根据设备属性决定deviceNature参数
        const deviceNature = this.deviceAttribute === 1 ? 1 : 2; // 正式进院=1, 试用=2
        
        const response = await this.$api.getRingDeviceList({
          deviceStatus: 1,
          deviceNature: deviceNature
        });
        
        const ringOptions = response.map(item => ({
          value: item.id,
          label: item.deviceSn,
          deviceSn: item.deviceSn, // 保存设备SN
          deviceHospitalName: item.deviceHospitalName // 保存原关联机构名称
        }));
        
        // 两个指环选择器使用相同的数据
        this.ring1List = ringOptions;
        this.ring2List = ringOptions;
      } catch (error) {
        console.error('获取指环列表失败:', error);
      }
    },

    onContractNumberInput: function (value) {
      this.contractNumber = value;
    },

    onContractSignatoryInput: function (value) {
      this.contractSignatory = value;
    },

    onDeviceAttributeChange: function (value) {
      // 根据设备属性自动设置设备状态
      if (value === 1) { // 正式进院
        this.deviceStatus = 2; // 已售
      } else if (value === 2) { // 试用
        this.deviceStatus = 3; // 流转中
      }
      this.outboundRing1 = null;
      this.outboundRing2 = null;
      // 重新获取指环列表（根据新的设备属性）
      this.getRingList();
    },

    onCloseClick: function () {
      this.$emit("onCloseClick");
    },

    onCancelClick: function () {
      this.onCloseClick();
    },

    onConfirmClick: function () {
      // 验证必填字段
      if (!this.deviceAttribute) {
        this.$toast.showRed("请选择设备属性");
        return;
      }
      if (!this.deviceStatus) {
        this.$toast.showRed("请选择设备状态");
        return;
      }
      if (!this.outboundPersonId) {
        this.$toast.showRed("请选择负责人");
        return;
      }

      // 验证两个同步出库指环值不能相同
      if (this.outboundRing1 && this.outboundRing2 && this.outboundRing1 === this.outboundRing2) {
        this.$toast.showRed("两个同步出库指环值需要不相同");
        return;
      }

      // 合并指环选择
      const outboundRingIds = [this.outboundRing1, this.outboundRing2].filter(ring => ring !== null);

      // 提交数据
      this.$emit("onConfirmClick", {
        deviceAttribute: this.deviceAttribute,
        deviceStatus: this.deviceStatus,
        outboundRingIds: outboundRingIds.join(),
        outboundPersonId: this.outboundPersonId,
        outboundHospitalId: this.outboundHospitalId,
        outboundTime: this.outboundTime,
        warrantyYears: this.warrantyYears,
        contractNumber: this.contractNumber,
        contractSignatory: this.contractSignatory,
        outboundRemarks: this.outboundRemarks,
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.device-outbound {
  width: rem(550);

  &-top {
    width: 100%;
    height: rem(55);
    border-bottom: rem(1) solid rgba($color: black, $alpha: 0.09);
    box-sizing: border-box;
    padding: rem(0) rem(24);
    display: flex;
    align-items: center;
    justify-content: space-between;

    &-title {
      color: rgba($color: black, $alpha: 0.85);
      font-size: rem(16);
    }

    &-close {
      width: rem(16);
      height: rem(16);
    }
  }

  &-middle {
    color: rgba($color: black, $alpha: 0.85);
    font-size: rem(14);
    line-height: rem(20);
    border-bottom: rem(1) solid rgba($color: black, $alpha: 0.09);
    width: 100%;
    max-height: rem(600);
    overflow-y: auto;
    padding: rem(20) rem(24);
    box-sizing: border-box;

    .required {
      color: #ff4d4f;
    }

    // 创建行容器
    .form-row {
      display: flex;
      gap: rem(20);
      margin-bottom: rem(16);

      .form-field {
        flex: 1;
        display: flex;
        flex-direction: column;
        gap: rem(8);

        &-title {
          font-weight: 500;
          margin: 0;
        }

        &-select,
        &-picker {
          ::v-deep .el-input {
            height: rem(32);
          }
        }

        &-input {
          height: rem(32);
        }

        &-textarea {
          ::v-deep .el-textarea__inner {
            min-height: rem(80);
          }
        }
      }
    }

    // 单独一行的字段
    .form-row-full {
      margin-bottom: rem(16);

      .form-field {
        display: flex;
        flex-direction: column;
        gap: rem(8);

        &-title {
          font-weight: 500;
          margin: 0;
        }

        &-input {
          height: rem(32);
        }
      }
    }
  }

  &-bottom {
    width: 100%;
    height: rem(73);
    box-sizing: border-box;
    padding-top: rem(10);
    padding-right: rem(16);
    display: flex;
    justify-content: flex-end;

    &-confirm {
      color: white;
      background-color: #325FAC;
      font-size: rem(14);
      border-radius: rem(3);
      width: rem(65);
      height: rem(32);
      display: flex;
      align-items: center;
      justify-content: center;
    }

    &-cancel {
      color: rgba($color: #000000, $alpha: 0.65);
      background-color: white;
      font-size: rem(14);
      border-radius: rem(3);
      border: rem(1) solid #e8e8e8;
      width: rem(65);
      height: rem(32);
      margin-right: rem(8);
      display: flex;
      align-items: center;
      justify-content: center;
    }
  }
  
  // 文案提示区域样式
  .form-tips {
    margin-top: rem(20);
    padding: rem(12) rem(16);
    background-color: #f6f8fa;
    border: rem(1) solid #e1e4e8;
    border-radius: rem(4);
    color: rgba($color: black, $alpha: 0.65);
    font-size: rem(12);
    line-height: rem(18);

    &-title {
      margin: 0 0 rem(8) 0;
      font-weight: 500;
      color: rgba($color: black, $alpha: 0.85);
    }

    &-content {
      p {
        margin: 0 0 rem(4) 0;
        padding-left: rem(12);
        
        &:last-child {
          margin-bottom: 0;
        }
      }
    }
  }
}
</style>